/*
 * @Description: 颜色列表
 * @Author: yy
 * @Date: 2020-05-08 13:46:50
 * @LastEditors: yy
 * @LastEditTime: 2020-05-08 14:02:26
 */

export default [{
  name: '默认颜色1',
  value: ['#dc8a03', '#f19601', '#f7ba5f', '#fcddb1']
}, {
  name: '默认颜色2',
  value: ['#850609', '#9e0307', '#bc3e41', '#d77d7f']
}, {
  name: '默认颜色3',
  value: ['#a44c34', '#c55d42', '#ec754d', '#f6bda2']
}, {
  name: '默认颜色4',
  value: ['#f0e301', '#fff001', '#fff46c', '#fff9bf']
  
}, {
  name: '世茂',
  value: ['#876034', '#9c7d59', '#bda78d', '#e0d6c7']

}, {
  name: '太古1',
  value: ['#0b4b4b', '#41726f', '#94aba5', '#d0d3cc']
}, {
  name: '太古2',
  value: ['#ab1d2b', '#b95055', '#d49897', '#e3cbc7']
}, {
  name: '太古3',
  value: ['#4a4a4b', '#6c6a6a', '#9f9d98', '#d7d3cb']
}, {
  name: '太古4',
  value: ['#1d5d9d', '#4f7faf', '#9bb1c6', '#d1d7d7']

}, {
  name: '海尔1',
  value: ['#0076bb', '#4093c9', '#8fc0df', '#e7f2f8']
}, {
  name: '海尔2',
  value: ['#00526c', '#367388', '#7ea5b3', '#d0dbe1']
}, {
  name: '海尔3',
  value: ['#01a2ff', '#50b8ff', '#a9ddff', '#e8f6ff']
}]



// WEBPACK FOOTER //
// src/routes/customChart/components/colors.js